import * as constants from 'redux/constants';
import * as utils from 'redux/utils';

const initialState = {
  loading: false,
  creating: false,
  refetch: false,
  chats: null,
};

export default function chats(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case constants.GET_CHATS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case constants.GET_CHATS_SUCCESS:
      return {
        ...state,
        loading: false,
        creating: false,
        chats: payload,
      };

    case constants.GET_CHATS_FAIL:
      return {
        ...state,
        loading: false,
      };

    case constants.CREATE_CHAT_REQUEST: {
      const newChats = utils.getChatForUser(state.chats, payload);
      return {
        ...state,
        creating: true,
        chats: newChats,
      };
    }

    case constants.CREATE_CHAT_SUCCESS: {
      const newChats = utils.getChatForAssistant(state.chats, payload);
      return {
        ...state,
        refetch: true,
        creating: false,
        chats: newChats,
      };
    }

    case constants.CREATE_CHAT_FAIL:
      return {
        ...state,
        creating: false,
      };

    default:
      return state;
  }
}
